import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import { getContrastColor } from "../../util/get-contrast-color"
import FpTooltip from "../tooltip/tooltip"
import "./effect.sass"

const Effect = ({
  effectLabel,
  effectBackgroundColor,
  effectTooltip,
  effectStyle,
}) => {
  const EffectLabel = () => {
    return (
      <p
        style={{ color: getContrastColor(effectBackgroundColor) }}
        className={"_fp-effect__circle__label"}
      >
        {effectLabel}
      </p>
    )
  }

  return (
    <div
      className={classNames(
        "_fp-effect",
        effectStyle === "full" ? "_fp-effect--full" : "",
      )}
    >
      {effectStyle === "condensed" ? (
        <FpTooltip label={effectTooltip}>
          <div
            style={{ backgroundColor: effectBackgroundColor }}
            className={"_fp-effect__circle"}
          >
            <EffectLabel />
          </div>
        </FpTooltip>
      ) : (
        <div
          style={{ backgroundColor: effectBackgroundColor }}
          className={"_fp-effect__circle"}
        >
          <EffectLabel />
        </div>
      )}
      {effectStyle === "full" && (
        <div className={"_fp-effect__label"}>
          <p>{effectTooltip}</p>
        </div>
      )}
    </div>
  )
}

Effect.propTypes = {
  effectLabel: PropTypes.string,
  effectBackgroundColor: PropTypes.string.isRequired,
  effectTooltip: PropTypes.string,
  effectStyle: PropTypes.oneOf(["full", "condensed"]),
}

Effect.defaultProps = {
  effectStyle: "condensed",
}

export default Effect
